if (('serviceWorker' in navigator) && ('PushManager' in window)) {
    navigator.serviceWorker.register('/worker.js')
        .then(function (registration) {
            $.askNotificationPermission();
            $.subscribeUserToPushNotification();

            return registration;
        });
}
